import { useEffect, useState } from 'react';
import { loadPartPrices } from '@/lib/demoScenes';

// Chips that print PART_META prices call this: it kicks the one-per-window
// price fetch and re-renders the caller when the admin's Parts figures have
// been patched in. Until then (or on any failure) the hard-coded fallback
// figures render — a chip is never blank and never flickers to zero.
export default function useLivePartPrices() {
  const [, setTick] = useState(0);
  useEffect(() => {
    let on = true;
    loadPartPrices().then((changed) => { if (on && changed) setTick((t) => t + 1); });
    return () => { on = false; };
  }, []);
}
